// Fashion Affiliate Product Data Layer
// Supports: image, title, brand, price, salePrice, description, category,
//           affiliateUrl, retailer, cta, editorialNote, badge, tracking

export const PRODUCTS = [
  // ─── BRIDAL GOWNS ────────────────────────────────────────────────────────────
  {
    id: 'gown_01',
    title: 'Ivory Silk Crêpe Column Gown',
    brand: 'Valentino Haute Couture',
    price: 12500,
    salePrice: null,
    description: 'A masterclass in restraint. Deep V-back, flawless bias cut, zero embellishment. Let the silk speak.',
    category: 'gowns',
    affiliateUrl: '#',
    retailer: 'Valentino',
    cta: 'Discover the Gown',
    editorialNote: 'As worn at last season\'s most photographed Amalfi wedding.',
    badge: "Editor's Pick",
    tracking: 'gown_01_valentino',
    image: 'https://images.unsplash.com/photo-1594938298603-c8148c4b4883?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'gown_02',
    title: 'Duchess Satin Ballgown with Cathedral Train',
    brand: 'Vera Wang',
    price: 8900,
    salePrice: null,
    description: 'Structured, sculptural, unforgettable. A modern take on the grande dame silhouette.',
    category: 'gowns',
    affiliateUrl: '#',
    retailer: 'Vera Wang',
    cta: 'View Gown',
    editorialNote: null,
    badge: 'New Season',
    tracking: 'gown_02_vera_wang',
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'gown_03',
    title: 'Lace & Tulle A-Line with Illusion Neckline',
    brand: 'Monique Lhuillier',
    price: 6800,
    salePrice: null,
    description: 'Romantic without being clichéd. The lace is hand-applied; the tulle skirt is ethereal in motion.',
    category: 'gowns',
    affiliateUrl: '#',
    retailer: 'Monique Lhuillier',
    cta: 'Shop Now',
    editorialNote: 'A perennial favourite with our brides.',
    badge: null,
    tracking: 'gown_03_monique',
    image: 'https://images.unsplash.com/photo-1537633552985-df8429e8048b?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'gown_04',
    title: 'Minimalist Crepe Sheath, The Modern Bride',
    brand: 'Roland Mouret',
    price: 4200,
    salePrice: 3150,
    description: 'For the bride who has read enough trend reports to know exactly what she wants: nothing superfluous.',
    category: 'gowns',
    affiliateUrl: '#',
    retailer: 'Net-a-Porter',
    cta: 'Shop Now',
    editorialNote: null,
    badge: 'Sale',
    tracking: 'gown_04_mouret',
    image: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'gown_05',
    title: 'Corseted Mikado Ball Gown',
    brand: 'Carolina Herrera',
    price: 9400,
    salePrice: null,
    description: 'Structured silk mikado with boned corseted bodice. Architecture in fabric form.',
    category: 'gowns',
    affiliateUrl: '#',
    retailer: 'Carolina Herrera',
    cta: 'Discover Now',
    editorialNote: 'The choice of a bride who wants to make an entrance.',
    badge: "Editor's Pick",
    tracking: 'gown_05_herrera',
    image: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?auto=format&fit=crop&w=600&q=80',
  },

  // ─── BRIDAL SHOES ─────────────────────────────────────────────────────────────
  {
    id: 'shoe_01',
    title: 'Satin Mule with Crystal Ankle Strap',
    brand: 'Jimmy Choo',
    price: 895,
    salePrice: null,
    description: 'The bridal shoe that never needs to be justified. Satin upper, crystal strap, 85mm block heel.',
    category: 'shoes',
    affiliateUrl: '#',
    retailer: 'Jimmy Choo',
    cta: 'Shop Now',
    editorialNote: null,
    badge: "Editor's Pick",
    tracking: 'shoe_01_choo',
    image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'shoe_02',
    title: 'White Satin Pointed Court Shoe',
    brand: 'Manolo Blahnik',
    price: 1150,
    salePrice: null,
    description: 'The Hangisi, reimagined in ivory satin for the modern bride. A punctuation mark on the perfect gown.',
    category: 'shoes',
    affiliateUrl: '#',
    retailer: 'Manolo Blahnik',
    cta: 'View Shoes',
    editorialNote: 'Sofia\'s personal choice for her Como trip.',
    badge: null,
    tracking: 'shoe_02_manolo',
    image: 'https://images.unsplash.com/photo-1515347619252-60a4bf4fff4f?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'shoe_03',
    title: 'Pearl-Embellished Kitten Heel Mule',
    brand: 'Roger Vivier',
    price: 720,
    salePrice: 540,
    description: 'Understated elegance. Pearl toe-strap detail on a 45mm kitten heel. Perfect for a long reception.',
    category: 'shoes',
    affiliateUrl: '#',
    retailer: 'Roger Vivier',
    cta: 'Shop Now',
    editorialNote: null,
    badge: 'Sale',
    tracking: 'shoe_03_vivier',
    image: 'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'shoe_04',
    title: 'Crystal-Embellished Block-Heel Sandal',
    brand: 'Aquazzura',
    price: 675,
    salePrice: null,
    description: 'Dance all night. Cushioned footbed, adjustable ankle strap, 70mm heel. Made in Italy.',
    category: 'shoes',
    affiliateUrl: '#',
    retailer: 'Aquazzura',
    cta: 'Discover More',
    editorialNote: 'Built for dancing. Designed to be admired.',
    badge: 'New Season',
    tracking: 'shoe_04_aquazzura',
    image: 'https://images.unsplash.com/photo-1571513722275-4b41940f54b8?auto=format&fit=crop&w=600&q=80',
  },

  // ─── BRIDAL JEWELLERY ─────────────────────────────────────────────────────────
  {
    id: 'jewel_01',
    title: 'Diamond Tennis Necklace in 18ct White Gold',
    brand: 'Graff',
    price: 28500,
    salePrice: null,
    description: '42 round brilliant diamonds, D–F colour, totalling 8.40ct. Simplicity at its most expensive.',
    category: 'jewellery',
    affiliateUrl: '#',
    retailer: 'Graff',
    cta: 'Enquire Now',
    editorialNote: null,
    badge: "Editor's Pick",
    tracking: 'jewel_01_graff',
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'jewel_02',
    title: 'Pearl and Gold Drop Earrings',
    brand: 'Mikimoto',
    price: 1850,
    salePrice: null,
    description: 'South Sea pearls set in 18ct yellow gold. The world\'s finest pearls, simply and perfectly set.',
    category: 'jewellery',
    affiliateUrl: '#',
    retailer: 'Mikimoto',
    cta: 'View Piece',
    editorialNote: 'Pearl jewellery has been the bridal choice for three centuries. Mikimoto does it best.',
    badge: null,
    tracking: 'jewel_02_mikimoto',
    image: 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'jewel_03',
    title: 'Art Deco Diamond Hairpiece',
    brand: 'Cartier',
    price: 14200,
    salePrice: null,
    description: 'Flexible diamond vine hairpiece inspired by the 1920s archive. Pave-set brilliant diamonds.',
    category: 'jewellery',
    affiliateUrl: '#',
    retailer: 'Cartier',
    cta: 'Discover More',
    editorialNote: null,
    badge: 'New Season',
    tracking: 'jewel_03_cartier',
    image: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'jewel_04',
    title: 'Sapphire and Diamond Bracelet',
    brand: 'Van Cleef & Arpels',
    price: 19800,
    salePrice: null,
    description: 'Ceylon sapphires alternating with round brilliant diamonds. Something blue, elevated.',
    category: 'jewellery',
    affiliateUrl: '#',
    retailer: 'Van Cleef & Arpels',
    cta: 'Enquire',
    editorialNote: 'The perfect \'something blue\' for the bride who collects rather than borrows.',
    badge: "Editor's Pick",
    tracking: 'jewel_04_vca',
    image: 'https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?auto=format&fit=crop&w=600&q=80',
  },

  // ─── BEAUTY ───────────────────────────────────────────────────────────────────
  {
    id: 'beauty_01',
    title: 'La Mer The Eye Concentrate',
    brand: 'La Mer',
    price: 260,
    salePrice: null,
    description: 'Eight weeks before the wedding: start here. Clinical-strength eye treatment with Miracle Broth.',
    category: 'beauty',
    affiliateUrl: '#',
    retailer: 'Space NK',
    cta: 'Shop Now',
    editorialNote: 'Begin your skin prep protocol 8 weeks out.',
    badge: "Editor's Pick",
    tracking: 'beauty_01_lamer',
    image: 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'beauty_02',
    title: 'Charlotte Tilbury Airbrush Flawless Foundation',
    brand: 'Charlotte Tilbury',
    price: 44,
    salePrice: null,
    description: 'The foundation of choice for bridal makeup artists worldwide. 24-hour wear, transfer-resistant.',
    category: 'beauty',
    affiliateUrl: '#',
    retailer: 'Charlotte Tilbury',
    cta: 'Shop Now',
    editorialNote: 'Used by our cover shoot makeup artist.',
    badge: null,
    tracking: 'beauty_02_ct',
    image: 'https://images.unsplash.com/photo-1522338242992-e1a54906a8da?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'beauty_03',
    title: 'Sisley Paris Hair Rituel Sculpting Mask',
    brand: 'Sisley Paris',
    price: 145,
    salePrice: null,
    description: 'Intense repair mask for bridal hair prep. For shine and resilience you will feel in photographs.',
    category: 'beauty',
    affiliateUrl: '#',
    retailer: 'Harvey Nichols',
    cta: 'Discover',
    editorialNote: null,
    badge: 'New Season',
    tracking: 'beauty_03_sisley',
    image: 'https://images.unsplash.com/photo-1571781926291-c477ebfd024b?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'beauty_04',
    title: 'Creed Fleurissimo Parfum',
    brand: 'Creed',
    price: 385,
    salePrice: null,
    description: 'Created for Grace Kelly\'s 1956 wedding. The finest bridal fragrance in the world. Full stop.',
    category: 'beauty',
    affiliateUrl: '#',
    retailer: 'Selfridges',
    cta: 'Shop Fragrance',
    editorialNote: 'Originally commissioned for Princess Grace. It has never been bettered.',
    badge: "Editor's Pick",
    tracking: 'beauty_04_creed',
    image: 'https://images.unsplash.com/photo-1587017539504-67cfbddac569?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'beauty_05',
    title: 'Dr. Barbara Sturm Glow Drops',
    brand: 'Dr. Barbara Sturm',
    price: 145,
    salePrice: null,
    description: 'The only skin serum to feature on every bridal prep list we\'ve ever compiled.',
    category: 'beauty',
    affiliateUrl: '#',
    retailer: 'Net-a-Porter',
    cta: 'Shop Now',
    editorialNote: null,
    badge: null,
    tracking: 'beauty_05_sturm',
    image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&w=600&q=80',
  },

  // ─── ACCESSORIES ──────────────────────────────────────────────────────────────
  {
    id: 'acc_01',
    title: 'Ivory Duchess Satin Bridal Clutch',
    brand: 'Judith Leiber',
    price: 1850,
    salePrice: null,
    description: 'Hand-beaded ivory satin minaudière with gold clasp. A wedding-night heirloom.',
    category: 'accessories',
    affiliateUrl: '#',
    retailer: 'Judith Leiber',
    cta: 'View Clutch',
    editorialNote: null,
    badge: "Editor's Pick",
    tracking: 'acc_01_leiber',
    image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'acc_02',
    title: 'Cathedral Veil with Satin Trim',
    brand: 'Bespoke Atelier',
    price: 680,
    salePrice: null,
    description: '4m cathedral veil in French silk tulle with a hand-rolled satin edge. Made to order in 8 weeks.',
    category: 'accessories',
    affiliateUrl: '#',
    retailer: 'The White Gallery',
    cta: 'Enquire',
    editorialNote: 'The veil is not optional. The veil is the photograph.',
    badge: null,
    tracking: 'acc_02_veil',
    image: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'acc_03',
    title: 'Crystal and Pearl Hair Comb',
    brand: 'Jennifer Behr',
    price: 425,
    salePrice: null,
    description: 'Freshwater pearls and rose-cut crystals on a gold-plated comb. The detail that ties everything together.',
    category: 'accessories',
    affiliateUrl: '#',
    retailer: 'Jennifer Behr',
    cta: 'Shop Now',
    editorialNote: null,
    badge: 'New Season',
    tracking: 'acc_03_behr',
    image: 'https://images.unsplash.com/photo-1583292650898-7d22cd27ca6f?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'acc_04',
    title: 'Ivory Silk Bridal Robe',
    brand: 'Morgan Lane',
    price: 295,
    salePrice: null,
    description: 'For the morning of. Silk charmeuse with delicate lace trim. The photographs begin here.',
    category: 'accessories',
    affiliateUrl: '#',
    retailer: 'Morgan Lane',
    cta: 'Shop Now',
    editorialNote: 'The most photographed item in any bridal suite.',
    badge: "Editor's Pick",
    tracking: 'acc_04_robe',
    image: 'https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?auto=format&fit=crop&w=600&q=80',
  },

  // ─── GUEST DRESSES ────────────────────────────────────────────────────────────
  {
    id: 'guest_01',
    title: 'Celestial Blue Silk Midi Dress',
    brand: 'Emilia Wickstead',
    price: 1650,
    salePrice: null,
    description: 'The considered wedding guest. Silk-faille midi with architectural bow detail. Zero risk of upstaging.',
    category: 'guest-dresses',
    affiliateUrl: '#',
    retailer: 'Emilia Wickstead',
    cta: 'Shop Now',
    editorialNote: 'Our editor\'s top pick for a Lake Como wedding.',
    badge: "Editor's Pick",
    tracking: 'guest_01_wickstead',
    image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'guest_02',
    title: 'Sage Printed Silk Maxi Dress',
    brand: 'Erdem',
    price: 1480,
    salePrice: 1110,
    description: 'Floral-printed silk maxi. The kind of dress that gets photographed by strangers at European weddings.',
    category: 'guest-dresses',
    affiliateUrl: '#',
    retailer: 'Matchesfashion',
    cta: 'Shop Now',
    editorialNote: null,
    badge: 'Sale',
    tracking: 'guest_02_erdem',
    image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'guest_03',
    title: 'Champagne Sequin Column Dress',
    brand: 'Jenny Packham',
    price: 2200,
    salePrice: null,
    description: 'Column dress in liquid gold sequins. For the evening reception when you want to be seen.',
    category: 'guest-dresses',
    affiliateUrl: '#',
    retailer: 'Jenny Packham',
    cta: 'Discover More',
    editorialNote: 'Wear this to a Tuscan summer wedding and do not apologise.',
    badge: null,
    tracking: 'guest_03_packham',
    image: 'https://images.unsplash.com/photo-1539008835657-9e8e9680c956?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'guest_04',
    title: 'Ivory Broderie Anglaise Midi Dress',
    brand: 'Self Portrait',
    price: 420,
    salePrice: null,
    description: 'Our most-requested summer wedding guest dress. Broderie anglaise with a square neckline.',
    category: 'guest-dresses',
    affiliateUrl: '#',
    retailer: 'ASOS Luxury',
    cta: 'Shop Now',
    editorialNote: null,
    badge: 'New Season',
    tracking: 'guest_04_self_portrait',
    image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=600&q=80',
  },

  // ─── HONEYMOON WARDROBE ────────────────────────────────────────────────────────
  {
    id: 'honey_01',
    title: 'Silk Pareo in Cream and Gold Print',
    brand: 'Missoni Mare',
    price: 385,
    salePrice: null,
    description: 'The defining piece of a Mediterranean honeymoon. Silk and viscose blend, hand-printed in Varese.',
    category: 'honeymoon',
    affiliateUrl: '#',
    retailer: 'Missoni',
    cta: 'Shop Now',
    editorialNote: 'Pack this first. Everything else builds around it.',
    badge: "Editor's Pick",
    tracking: 'honey_01_missoni',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80',
  },
  {
    id: 'honey_02',
    title: 'Linen Wide-Leg Trouser in Ivory',
    brand: 'Max Mara',
    price: 395,
    salePrice: null,
    description: 'The foundational honeymoon piece. Wear with sandals for dinner, barefoot for breakfast.',
    category: 'honeymoon',
    affiliateUrl: '#',
    retailer: 'Max Mara',
    cta: 'Shop Now',
    editorialNote: null,
    badge: null,
    tracking: 'honey_02_maxmara',
    image: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=600&q=80',
  },
];

// ─── Collections ──────────────────────────────────────────────────────────────
export const COLLECTIONS = {
  'bridal-gowns': {
    label: 'Bridal Gowns',
    subtitle: 'The defining choice',
    productIds: ['gown_01', 'gown_02', 'gown_03', 'gown_04', 'gown_05'],
  },
  'bridal-shoes': {
    label: 'Shoes',
    subtitle: 'Walk the aisle in',
    productIds: ['shoe_01', 'shoe_02', 'shoe_03', 'shoe_04'],
  },
  'bridal-jewellery': {
    label: 'Jewellery',
    subtitle: 'Wear forever',
    productIds: ['jewel_01', 'jewel_02', 'jewel_03', 'jewel_04'],
  },
  'bridal-beauty': {
    label: 'Beauty',
    subtitle: 'The prep edit',
    productIds: ['beauty_01', 'beauty_02', 'beauty_03', 'beauty_04', 'beauty_05'],
  },
  'accessories-edit': {
    label: 'Accessories',
    subtitle: 'The finishing touches',
    productIds: ['acc_01', 'acc_02', 'acc_03', 'acc_04'],
  },
  'guest-dresses': {
    label: 'Guest Dresses',
    subtitle: 'For every type of wedding',
    productIds: ['guest_01', 'guest_02', 'guest_03', 'guest_04'],
  },
  'honeymoon-wardrobe': {
    label: 'Honeymoon Wardrobe',
    subtitle: 'Pack beautifully',
    productIds: ['honey_01', 'honey_02'],
  },
  // Shop the Story collections (used inline in articles)
  'silhouette-2026-gowns': {
    label: 'Gowns',
    subtitle: 'Shop the story',
    productIds: ['gown_01', 'gown_04', 'gown_05'],
  },
  'silhouette-2026-shoes': {
    label: 'Shoes',
    subtitle: 'Complete the look',
    productIds: ['shoe_01', 'shoe_02', 'shoe_04'],
  },
  'silhouette-2026-jewellery': {
    label: 'Jewellery',
    subtitle: 'The details',
    productIds: ['jewel_01', 'jewel_02'],
  },
  'silhouette-2026-beauty': {
    label: 'Beauty',
    subtitle: 'The prep',
    productIds: ['beauty_01', 'beauty_04', 'beauty_05'],
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
export function getProductById(id) {
  return PRODUCTS.find(p => p.id === id) || null;
}

export function getProductsByCollection(collectionId) {
  const col = COLLECTIONS[collectionId];
  if (!col) return [];
  return col.productIds.map(id => getProductById(id)).filter(Boolean);
}

export function getProductsByCategory(category) {
  return PRODUCTS.filter(p => p.category === category);
}

export function formatPrice(price, currency = '£') {
  if (typeof price === 'string') return price;
  return `${currency}${price.toLocaleString('en-GB')}`;
}
